<template>
  <div class="QS-table" :style="{ '--qs-table': overAllQs != 0 ? 5 : 4 }">
    <table>
      <thead>
        <tr>
          <th>{{ $t('current-exercise') }}</th>
          <th v-if="overAllQs != 0">{{ $t('current-session') }}</th>
          <th>{{ $t('all-weights') }}</th>
          <th>{{ $t('this-weight') }}</th>
          <th>{{ $t('last-5-session') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-primary first-cl flex qs-first-sec"><img
              :src="fit20.storageBaseUrl + '/static/icons/Quality-score.png'" /> <span>{{
                QS.average &&
                  QS.average > 0 ?
                  QS.average : '-' }}</span></td>
          <td class="overAllQs" v-if="overAllQs != 0">{{ overAllQs && overAllQs.qs_average ? overAllQs.qs_average : '-'
          }}</td>
          <td>
            <div
              :class="bestPersonalClass(QS.average, personalBest.allWeights.average, personalBest.allWeights.average2, 'green')">
              {{
                personalBest.allWeights.average && personalBest.allWeights.average > 0 ?
                  personalBest.allWeights.average : '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.average, personalBest.thisWeight.average, personalBest.thisWeight.average2, 'green')">
              {{
                personalBest.thisWeight.average && personalBest.thisWeight.average > 0 ?
                  personalBest.thisWeight.average : '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.average, personalBest.last5Session.average, personalBest.last5Session.average2, 'green')">
              {{ personalBest.last5Session.average && personalBest.last5Session.average > 0 ?
                personalBest.last5Session.average : '-'
              }}</div>
          </td>
        </tr>
        <tr>
          <td class="pink first-cl flex qs-first-sec"><img
              :src="fit20.storageBaseUrl + '/static/icons/Tempo.png'" /><span>{{
                QS.tempo &&
                  QS.tempo >
                  0 ? QS.tempo
                  : '-' }}</span></td>
          <td class="overAllQs" v-if="overAllQs != 0">{{ overAllQs && overAllQs.qs_tempo ? overAllQs.qs_tempo : '-' }}
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.tempo, personalBest.allWeights.tempo, personalBest.allWeights.tempo2, 'pink')">
              {{
                personalBest.allWeights.tempo && personalBest.allWeights.tempo > 0 ? personalBest.allWeights.tempo :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.tempo, personalBest.thisWeight.tempo, personalBest.thisWeight.tempo2, 'pink')">
              {{
                personalBest.thisWeight.tempo && personalBest.thisWeight.tempo > 0 ? personalBest.thisWeight.tempo :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.tempo, personalBest.last5Session.tempo, personalBest.last5Session.tempo2, 'pink')">
              {{
                personalBest.last5Session.tempo && personalBest.last5Session.tempo > 0 ?
                  personalBest.last5Session.tempo : '-' }}</div>
          </td>
        </tr>
        <tr>
          <td class="text-secondary flex qs-first-sec"><img
              :src="fit20.storageBaseUrl + '/static/icons/Rhythm.png'" /><span>{{
                QS.rhythm && QS.rhythm > 0 ?
                  QS.rhythm : '-' }}</span></td>
          <td class="overAllQs" v-if="overAllQs != 0">{{ overAllQs && overAllQs.qs_rhythm ? overAllQs.qs_rhythm : '-' }}
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.rhythm, personalBest.allWeights.rhythm, personalBest.allWeights.rhythm2, 'blue')">
              {{
                personalBest.allWeights.rhythm && personalBest.allWeights.rhythm > 0 ? personalBest.allWeights.rhythm :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.rhythm, personalBest.thisWeight.rhythm, personalBest.thisWeight.rhythm2, 'blue')">
              {{
                personalBest.thisWeight.rhythm && personalBest.thisWeight.rhythm > 0 ? personalBest.thisWeight.rhythm :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.rhythm, personalBest.last5Session.rhythm, personalBest.last5Session.rhythm2, 'blue')">
              {{
                personalBest.last5Session.rhythm && personalBest.last5Session.rhythm > 0 ?
                  personalBest.last5Session.rhythm : '-' }}</div>
          </td>
        </tr>
        <tr>
          <td class="orange flex qs-first-sec"><img :src="fit20.storageBaseUrl + '/static/icons/Range.png'" /> <span>{{
            QS.range &&
              QS.range
              > 0 ?
              QS.range : '-' }}</span></td>
          <td class="overAllQs" v-if="overAllQs != 0">{{ overAllQs && overAllQs.qs_range ? overAllQs.qs_range : '-' }}
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.range, personalBest.allWeights.range, personalBest.allWeights.range2, 'orange')">
              {{
                personalBest.allWeights.range && personalBest.allWeights.range > 0 ? personalBest.allWeights.range :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.range, personalBest.thisWeight.range, personalBest.thisWeight.range2, 'orange')">
              {{
                personalBest.thisWeight.range && personalBest.thisWeight.range > 0 ? personalBest.thisWeight.range :
                  '-' }}</div>
          </td>
          <td>
            <div
              :class="bestPersonalClass(QS.range, personalBest.last5Session.range, personalBest.last5Session.range2, 'orange')">
              {{
                personalBest.last5Session.range && personalBest.last5Session.range > 0 ?
                  personalBest.last5Session.range : '-' }}</div>
          </td>
        </tr>
        <!-- <tr v-if="trainingAge">
          <td class="flex qs-first-sec"><img :src="fit20.storageBaseUrl + '/static/icons/fit20-age.png'" /> <span>{{
            trainingAge ?
              trainingAge : '-' }}</span></td>
          <td class="overAllQs">{{ trainingAge ? trainingAge : '-' }}</td>
          <td>
            <div></div>
          </td>
          <td>
            <div></div>
          </td>
          <td>
            <div></div>
          </td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: "QS",
  props: ["fit20", "QS", "personalBest", "overAllQs", "trainingAge"],
  methods: {
    bestPersonalClass: function (current, old, bestPersonal, color) {
      let bestPersonalClass = 'td-div';
      if (current && current > 0 && old && old > 0) {
        if (current == old && bestPersonal) {
          bestPersonalClass = "td-div normal-border-" + color;
        } else if (current == old) {
          bestPersonalClass = "td-div dashed-border-" + color;
        }
      }
      return bestPersonalClass;
    }
  }
};
</script>

<style>
.QS-table {
  background-color: white;
}

.qs-first-sec {
  width: 100% !important;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.QS-table th {
  font-size: 10px;
  width: calc(100% / var(--qs-table));
  text-align: center;
  font-weight: unset;
}

.QS-table td {
  font-size: 11px;
  width: calc(100% / var(--qs-table));
  text-align: center;
  /* margin-top: 3px; */

}

.QS-table tr {
  height: 20px;
}

.QS-table img {
  width: 20px;
  margin-right: 5px;
  /* margin-top: 3px; */
}

.first-cl {
  padding-bottom: 2px;
}

.normal-border-blue {
  border: solid 1px var(--fit20-blue);
}

.normal-border-green {
  border: solid 1px var(--fit20-green);
}

.normal-border-pink {
  border: solid 1px var(--fit20-pink);
}

.normal-border-orange {
  border: solid 1px var(--fit20-orang);
}

.dashed-border-blue {
  border: dashed 1px var(--fit20-blue);
}

.dashed-border-green {
  border: dashed 1px var(--fit20-green);
}

.dashed-border-pink {
  border: dashed 1px var(--fit20-pink);
}

.dashed-border-orange {
  border: dashed 1px var(--fit20-orang);
}

.td-div {
  margin: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding: 3px;
}

.overAllQs {
  color: var(--fit20-light-gray);
}
</style>
